<style lang="scss" scope>
.ivu-tabs .ivu-tabs-tabpane {
  flex-shrink: 0;
  width: 100%;
  transition: opacity 0.3s;
  opacity: 1;
  outline: none;
}
.ivu-modal-wrap * {
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.ivu-pb,
.ivu-pb-16 {
  padding-bottom: 16px !important;
}
.row[data-v-75eea3a4] {
  display: flex;
  border-bottom: 1px dashed #dee5e7;
  padding: 10px;
}
.row .col[data-v-75eea3a4] {
  width: 0;
  flex: 1;
  display: flex;
  padding: 0 15px;
}
.row .col .label[data-v-75eea3a4] {
  padding: 0 15px;
  flex-shrink: 0;
  width: 100px;
}
.row .col > div[data-v-75eea3a4] {
  padding: 14px 15px;
  font-weight: 700;

  .cell {
    text-align: center;
  }
}
</style>
<template>
  <div class="l-edit-dialog-box" style="padding-top:15px">
    <el-form>
        <div>
            <h3>隐患描述</h3>
            <p>{{hiddenList.danger}}</p>
        </div>
        
        <div>
            <h3>整改建议</h3>
            <el-form-item label="" prop="rectification">
                <el-input type="textarea" v-model="hiddenList.rectification" autocomplete="off" :rows="2" maxlength="250" placeholder="请输入" show-word-limit></el-input>
            </el-form-item>
        </div>
        <div>
            <h3>隐患位置</h3>
            <el-form-item label="" prop="location">
                <el-input type="textarea" v-model="hiddenList.location" autocomplete="off" :rows="2" maxlength="250" placeholder="请输入" show-word-limit></el-input>
            </el-form-item>
        </div>
        
        <div>
            <h3>隐患图片</h3>
            <el-form-item label="" prop="remark">
                <l-upload-img multiple method="place_hiddenPhoto" accept=".jpg,.png,.bmp" name="img" :on-success="(res)=>handleUploadSuccess(res,'photo')" :preview-url="photo_preview">
                </l-upload-img>
            </el-form-item>
        </div>
        
        <div>
            <h3>整改图片</h3>
            <el-form-item label="" prop="remark">
                <l-upload-img multiple method="place_hiddenPhoto" accept=".jpg,.png,.bmp" name="img" :on-success="(res)=>handleUploadSuccess(res,'rectification_photo')" :preview-url="rectification_photo_preview">
                </l-upload-img>
            </el-form-item>
        </div>
        <div>
            <h3>排查情况</h3>
            <p>排查员：{{hiddenList.review_name}}，排查时间：{{hiddenList.review_at}}</p>
        </div>
        <div>
            <h3>整改情况</h3>
            <p>整改员：{{hiddenList.rectification_name}}，整改时间：{{hiddenList.rectification_at}}</p>
        </div>
    </el-form>
   
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>

</template>

<script>

export default {
  name: 'l-hidden-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    place_id:{
      type: [String, Number],
      default: null
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();
        }
      }
    },
  },
  data() {
    return {
      loading: false,//页面是否加载中
      //表单数据
      form_data: {
        photo:"",
        rectification_photo:""
      },
      facade_photo: "",
      danger_notification_photo: "",
      signature_photo: "",
      sign_for_photo: "",
      work_photo: "",
      activeName: 'first',
      info_data: {},
      percentage: 0,

      find:{},
      hidden_log:[],
      hiddenList:{}
    }
  },
  methods: {
    getData() {
        this.loading = true;
        this.$_invoke(`place_hiddenDetails`, { hidden_id: this.$props.id
        }).then((ret) => {
            this.hiddenList = ret;
            this.form_data.photo=ret.photo;
            this.photo_preview = ret.photo;
            this.form_data.rectification_photo=ret.rectification_photo;
            this.rectification_photo_preview = ret.rectification_photo;
        }).finally(() => {
          this.loading = false;
        });
    },
    //上传图标成功后的回调
    handleUploadSuccess(res, field) {
      this.form_data[field]=[res.data.photo];
      this[field + "_preview"] = res.data.photo;
      // console.log(res.data)
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleSubmit(){
      // console.log(this.hiddenList);
      this.submitting = true;
      this.$_invoke('place_hiddenUpdate',{
        "place_id":this.place_id,
        "hidden_id":this.id,
        "photo":this.form_data.photo,
        "rectification_photo":this.form_data.rectification_photo,
        "location":this.hiddenList.location||"",
        "rectification":this.hiddenList.rectification
      }).then(() => {
        this.$_msg.success('修改成功');
        this.$emit('on-success');
      }).finally(() => {
        this.submitting = false;
      })
    }
  },
}
</script>